/* eslint-disable react-hooks/exhaustive-deps */
import { RNGProviderProps, RNGStateType, RNGValueType } from '@src/lib/types/rng';
import { useInputHelper } from '@src/utils/inputs-helper';
import _debounce from 'lodash/debounce';
import { createContext, useCallback, useContext, useState } from 'react';
import { useService } from './hooks';

const initialState: RNGStateType = {
  page: 0,
  order: 'desc',
  orderBy: 'CreatedDate',
  rowsPerPage: 10,
  editDetails: {},
  openCreate: false,
  search: "",
  code: "",
  debouncedCode: "",
  numWinners: "",
}

export const RNGContext = createContext<RNGValueType>({} as RNGValueType);

const RNGProvider = ({ children }: RNGProviderProps) => {
  const { runDraw } = useService();
  const [ error ] = useState({});
  const [ viewWinners, setViewWinners ] = useState({});
  const { state, onDispatch } = useInputHelper(initialState);

  const { mutate, data, isPending } = runDraw;

  const debouncedCodeFn = (value: string) => onDispatch('debouncedCode')(value);

  const handleDebouncedCode = useCallback(_debounce(debouncedCodeFn, 1000), []);

  const handleCodeInput = (value: string) => {
    onDispatch('code')(value);
    handleDebouncedCode(value);
  }

  const handleRunDraw = () => {
    mutate({
      raffleCode: state.code,
      numWinners: state.numWinners
    });
  }
  
  const value = {
    state,
    error,
    isLoading: isPending,
    rngResult: data || {},
    handleRunDraw,
    onDispatch,
    handleCodeInput,
    viewWinners, setViewWinners
  };

  return (
    <RNGContext.Provider value={value}>
      {children}
    </RNGContext.Provider>
  );
};

export const useRNG = () => {
  return useContext(RNGContext);
}

export default RNGProvider;
